import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/helpers/user-auth.guard';

const routes: Routes = [
  {
    path: 'software-versions',
    loadChildren: () =>
      import('./administration/software-versions/software-version.module').then(
        (m) => m.SoftwareVersionsModule,
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'products',
    loadChildren: () =>
      import('./administration/products/products.module').then(
        (m) => m.ProductsModule,
      ),
  },
  {
    path: 'distributors',
    loadChildren: () =>
      import('./operation/distributors/distributors.module').then(
        (m) => m.DistributorsModule,
      ),
  },
  {
    path: 'operators',
    loadChildren: () =>
      import('./operation/operators/operators.module').then(
        (m) => m.OperatorsModule,
      ),
  },
  {
    path: 'locations',
    loadChildren: () =>
      import('./operation/locations/locations.module').then(
        (m) => m.LocationsModule,
      ),
  },
  {
    path: 'terminals',
    loadChildren: () =>
      import('./operation/terminals/terminals.module').then(
        (m) => m.TerminalsModule,
      ),
  },
  {
    path: 'call-in-fill',
    loadChildren: () =>
      import('./operation/call-in-fill/call-in-fill.module').then(
        (m) => m.CallInFillModule,
      ),
  },
  {
    path: 'fugs',
    loadChildren: () =>
      import('./operation/fugs/fugs.module').then(
        (m) => m.FugsModule,
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'fill-prices',
    loadChildren: () =>
      import('./administration/fill-prices/fill-prices.module').then(
        (m) => m.FillPricesModule,
      ),
  },
  {
    path: 'fill-servers',
    loadChildren: () =>
      import('./administration/fill-server/fill-server.module').then(
        (m) => m.FillServerModule,
      ),
  },
  {
    path: 'fill-dongles',
    loadChildren: () =>
      import('./administration/fill-dongles/fill-dongles.module').then(
        (m) => m.FillDonglesModule,
      ),
  },
  {
    path: 'product-settings',
    loadChildren: () =>
      import('./administration/product-settings/product-settings.module').then(
        (m) => m.ProductSettingsModule,
      ),
  },
  {
    path: 'approvals/operators',
    loadChildren: () =>
      import('./approvals/operators/operator-approval.module').then(
        (m) => m.OperatorApprovalModule,
      ),
  },
  {
    path: 'approvals/terminals',
    loadChildren: () =>
      import('./approvals/terminals/terminal-approval.module').then(
        (m) => m.TerminalApprovalModule,
      ),
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'approvals/locations',
    loadChildren: () =>
      import('./approvals/locations/location-contract-approval.module').then(
        (m) => m.LocationContractApprovalModule,
      ),
  },
  {
    path: 'pom-trak-violations',
    loadChildren: () =>
      import('./pom-trak/pom-trak.module').then((m) => m.PomTrakModule),
  },
  {
    path: 'fill-blocks',
    loadChildren: () =>
      import('./fill-blocks-management/fill-blocks-management.module').then(
        (m) => m.FillBlocksModule,
      ),
  },
  {
    path: 'software-update-management',
    loadChildren: () =>
      import('./operation/software-releases/software-release-management.module').then(
        (m) => m.SoftwareReleaseManagementModule,
      ),
  },
  {
    path: 'reports/bill-acceptor',
    loadChildren: () =>
      import('./reports/bill-acceptor/bill-acceptor.module').then(
        (m) => m.BillAcceptorModule,
      ),
  },
  {
    path: 'reports/cash-in-out',
    loadChildren: () =>
      import('./reports/cash-in-out/cash-in-out.module').then(
        (m) => m.CashInOutModule,
      ),
  },
  {
    path: 'reports/terminal-info',
    loadChildren: () =>
      import('./reports/terminal-info/terminal-info.module').then(
        (m) => m.TerminalInfoModule,
      ),
  },
  {
    path: 'reports/fills',
    loadChildren: () =>
      import('./reports/fills/fills-module').then((m) => m.FillsModule),
  },
  {
    path: 'reports/saved-reports',
    loadChildren: () =>
      import('./reports/saved-reports/saved-reports.module').then((m) => m.SavedReportsModule),
  },
  {
    path: 'reports/terminal-error',
    loadChildren: () =>
      import('./reports/terminal-error/terminal-error.module').then((m) => m.TerminalErrorModule),
  },
  {
    path: 'reports/game-play-level',
    loadChildren: () =>
      import('./reports/game-play-level/game-play-level.module').then((m) => m.GamePlayLevelModule),
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
